import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetCourseState, setLoading, setStep } from '../../../../../../redux/slices/courseSlice';
import SubmitButtons from '../SubmitButtons';
import SwitchButton from '../../../../../common/SwitchButton';
import { createCourse, createSection, createSubSection } from '../../../../../../services/operations/courseApi';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { COURSE_STATUS } from '../../../../../../utils/constants';
import updateUserLocalStorage from '../../../../../../utils/updateUserLocalStorage';

const Publish = () => {
  const dispatch = useDispatch();
  const { course, courseInformation, loading } = useSelector(state => state.course);
  const navigate = useNavigate();
  const [publishOrDraft, setPublishOrDraft] = useState(COURSE_STATUS.DRAFT);

  const handlePublishSubmit = async () => {
    try {
      dispatch(setLoading(true));
      const courseCreateApiResponse = await createCourse(courseInformation, publishOrDraft);
      const createSectionsPromise = new Promise(async (resolve, reject) => {
        try {
          for (const element of course) {
            const sectionName = Object.keys(element)[0];
            const courseID = courseCreateApiResponse.data.data._id;
            const sectionCreateApiResponse = await createSection(sectionName, courseID);

            for (const subElement of element[sectionName]) {
              const sectionID = sectionCreateApiResponse.data.newSection._id;
              try {
                await createSubSection(sectionID, subElement, courseID);
              } catch (error) {
                console.log('Error while creating sub-section - ', error.message);
              }
            }
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
      await createSectionsPromise;

    } catch (error) {
      console.error('Error in publish.jsx while uploading course information:', error.message);

    } finally {
      dispatch(setLoading(false));
      toast.success("Course Created Successfully");
      await updateUserLocalStorage(dispatch);
      navigate('/dashboard/my-courses');
      dispatch(resetCourseState());
    }
  };

  const resetHandler = () => {
    dispatch(resetCourseState());
  };

  const backHandler = () => {
    dispatch(setStep(2));
  };
  return (
    <div>
      <div
        className='w-full flex flex-col justify-center gap-x-3 text-lg font-semibold p-[1.5rem] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
        style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
      >
        <p>Would you like to publish your course or save it as a draft?</p>
      </div>
      <div>
        <SwitchButton
          firstHandler={() => setPublishOrDraft(COURSE_STATUS.DRAFT)}
          firstName='Draft'
          secondHandler={() => setPublishOrDraft(COURSE_STATUS.PUBLISHED)}
          secondName='Publish'
          selectedType={publishOrDraft}
          type1='Draft'
          type2='Published'
        />
      </div>
      <div>
        <SubmitButtons
          submitText={publishOrDraft === COURSE_STATUS.DRAFT ? loading ? 'Saving...' : 'Save' : loading ? 'Launching...' : 'Launch'}
          resetText='Reset'
          cancelText='Back'
          submitType='button'
          resetType='reset'
          submitHandler={handlePublishSubmit}
          resetHandler={resetHandler}
          cancelHandler={backHandler}
        />
      </div>
    </div>
  );
};

export default Publish;